import React, { useEffect, useState } from "react";
import LiveIcon from "../../../../../assets/images/Souvenir/live.png";

import axios from "axios";
import SuperstarAuctionNav from "./SupestarAuctionNav/SuperstarAuctionNav";
import ProductCardStar from "./ProductCardStar";
import LoaderPost from "../../../../Reuseable/LoaderPost";

const SuperstarLiveNowAuction = () => {
  const [liveProduct, setLiveProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axios.get(`/api/star/live/allProduct`).then((res) => {
      if (res.status === 200) {
        setLiveProduct(res.data.products);
      }
      setLoading(false);
    });
  }, []);

  return (
    <>
      <div className="AS m-3">
        <SuperstarAuctionNav />
        <div className="d-flex mb-4  head-line p-3">
          <div className=" d-flex">
            <img src={LiveIcon} className=" SouvenirIcon" alt="" />
          </div>

          <div className=" d-flex text-light fw-bold mt-1 mx-3 ">Live Now</div>
        </div>

        {loading ? <LoaderPost /> : <ProductCardStar data={liveProduct} />}
      </div>
    </>
  );
};

export default SuperstarLiveNowAuction;
